import { EnvironmentProviders, inject, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';

import { Ability } from '@casl/ability';
import { Store } from '@ngrx/store';

import { AbilityStore } from '@app/auth/ability/ability.store';
import { SlnkAbility } from '@app/auth/ability/ability.token';
import { createSlnkAbility } from '@app/auth/ability/ability.utils';
import { selectUserUuid } from '@app/auth/store/selectors/user.selectors';
import { SlnkMongoAbility } from '@app/models/api/v1/auth/ability.model';

export function provideAppAbility(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SlnkAbility,
      useFactory: (): SlnkMongoAbility => createSlnkAbility(),
    },
    {
      provide: Ability,
      useExisting: SlnkAbility,
    },
    provideEnvironmentInitializer(() => {
      const abilityStore = inject(AbilityStore);
      const ngrxStore = inject(Store);

      abilityStore.userUuid.connect(ngrxStore.selectSignal(selectUserUuid));
    }),
  ]);
}
